import React from 'react'
import { Box, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import classes from './Footer.module.css'

import Paragraph from '../Paragraph/Paragraph';
import { collegePhoneNumbers } from '../../utils/constant';

const Footer = (props) => {

    let collegeName = props.college;
    
    // Get the phone number for the college, default to Kewdale if not found
    const collegePhone = collegePhoneNumbers[collegeName] || '(08) 9362 2100';
    const collegePhoneHref = collegePhone.replace(/\s+/g, ''); // Remove spaces for tel: link
    
    return (
        <Box className={`${classes.footerOuter}`}>
            <div className={`${classes.divider}`}></div>
            <Grid container spacing={0} className={classes.footerGrid}>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Paragraph fontSize={'18px'} margin={'10px 0 0 0'} textalign={'center'} text={"For further assistance:"} />
                </Grid>

                <Grid item xs={12} className={classes.contactRow}>
                    <Typography variant="p" component="p" className={`${classes.text}`}>
                        <strong>Email:</strong> <a className={`${classes.link}`} href="mailto:helpdesk@aic.wa.edu.au">helpdesk@aic.wa.edu.au</a>
                    </Typography>
                    <Typography variant="p" component="p" className={`${classes.text}`}>
                        <strong>Dialogue/WhatsApp:</strong> <a className={`${classes.link}`} href="tel:+61893622100">+61 8 9362 2100</a>
                    </Typography>
                </Grid>

                <Grid item xs={12} className={classes.contactBlock}>
                    <Typography variant="p" component="p" className={`${classes.text}`}>
                        <a className={`${classes.link}`} href={`tel:${collegePhoneHref}`}>{collegePhone}</a>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer